import React from "react";

const isoStandards = [
  { code: "ISO 2553", desc: "Welded, brazed and soldered joints – Symbolic representation on drawings (1992)" },
  { code: "ISO 2560", desc: "Covered electrodes for manual metal arc welding of non-alloy and fine grain steels. Classification" },
  { code: "ISO 3580", desc: "Covered electrodes for manual arc welding of creep-resisting steels – Code of symbols for identification" },
  { code: "ISO 3581", desc: "Covered electrodes for manual arc welding of stainless and similar high-alloy steels – Code of symbols for identification" },
  { code: "ISO 3834", desc: "Quality requirements for fusion welding of metallic materials (five parts)" },
  { code: "ISO 4063", desc: "Welding and allied processes – Nomenclature of processes and reference numbers" },
  { code: "ISO 5817", desc: "Fusion-welded joints – Quality levels for imperfections" },
  { code: "ISO 6520-1", desc: "Classification of geometric imperfections – Part 1" },
  { code: "ISO 6947", desc: "Welds – Working positions" },
  { code: "ISO 9606", desc: "Qualification test of welders" },
];

const asmeStandards = [
  { section: "ASME Section I", desc: "Power boilers" },
  { section: "ASME Section II", desc: "Materials" },
  { section: "ASME Section III", desc: "Rules for construction of nuclear power plant components" },
  { section: "ASME Section IV", desc: "Heating boilers" },
  { section: "ASME Section V", desc: "Non-destructive testing" },
  { section: "ASME Section VI", desc: "Care and operation of heating boilers" },
  { section: "ASME Section VII", desc: "Care of power boilers" },
  { section: "ASME Section VIII", desc: "Pressure vessels – Division 1" },
  { section: "ASME Section IX", desc: "Welding and brazing qualifications" },
  { section: "ASME Section X", desc: "Fiber-reinforced plastic pressure vessels" },
  { section: "ASME Section XI", desc: "In-service inspection of nuclear power plant components" },
  { section: "ASME Section XII", desc: "Transport tanks construction and service" },
  { section: "ASME B31.1", desc: "Power piping" },
  { section: "ASME B31.2", desc: "Fuel gas piping" },
  { section: "ASME B31.3", desc: "Process piping" },
  { section: "ASME B31.4", desc: "Pipeline transportation systems for liquid hydrocarbons" },
  { section: "ASME B31.5", desc: "Refrigeration piping and heat exchanger components" },
  { section: "ASME B31.8", desc: "Gas transmission and distribution piping systems" },
  { section: "ASME B31.9", desc: "Building services piping" },
];

const IsoStandard = () => {
  return (
    <div className="bg-white">

      {/* PAGE HEADER */}
      <div className="bg-gray-800 py-16">
        <h1 className="text-4xl md:text-5xl font-bold text-white text-center">
          ISO & ASME STANDARDS
        </h1>
      </div>

      {/* ISO TABLE */}
      <section className="py-16 container mx-auto px-4">
        <h2 className="text-3xl font-bold text-center mb-8 text-gray-800">
          LIST OF ISO STANDARDS
        </h2>

        <div className="overflow-x-auto">
          <table className="w-full border border-gray-300">
            <thead className="bg-gray-800 text-white">
              <tr>
                <th className="border px-4 py-3">ISO CODE</th>
                <th className="border px-4 py-3">DESCRIPTION</th>
              </tr>
            </thead>
            <tbody>
              {isoStandards.map((item, index) => (
                <tr key={index} className="hover:bg-gray-100">
                  <td className="border px-4 py-2 font-semibold">{item.code}</td>
                  <td className="border px-4 py-2">{item.desc}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      {/* ASME TABLE */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-8 text-gray-800">
            LIST OF ASME STANDARDS
          </h2>

          <div className="overflow-x-auto">
            <table className="w-full border border-gray-300">
              <thead className="bg-blue-800 text-white">
                <tr>
                  <th className="border px-4 py-3">SECTION</th>
                  <th className="border px-4 py-3">DESCRIPTION</th>
                </tr>
              </thead>
              <tbody>
                {asmeStandards.map((item, index) => (
                  <tr key={index} className="hover:bg-blue-50">
                    <td className="border px-4 py-2 font-semibold">{item.section}</td>
                    <td className="border px-4 py-2">{item.desc}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

    </div>
  );
};

export default IsoStandard;
